import React, { useState, useEffect } from 'react';
import { Modal, Typography, Box, Button, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, IconButton } from '@mui/material/';
import LocalFilerRecord from '../dataObjects/LocalFilerRecord';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';


interface Props {
    localFilersWithUnfiledReports: LocalFilerRecord[];
    handleOpenFilerDialog: (record: LocalFilerRecord, editing: boolean) => void;
    handleOpenReportDialog: (record: LocalFilerRecord, editing: boolean) => void;
    handleDelete: (localFilerRecordId: number) => Promise<void>;
    handleArchive: (localFilerRecordId: number) => Promise<void>;
    getLocalFilersWithUnfiledReports: () => void;
    handleSort: (field: string) => void;
    sortField: string;
    sortDirection: string;
    handleRefer: (name: string, localFilerID: number) => void;
    isArchived?: boolean;
}


const FilerRecordsTable = (props: Props) => {

    const renderSortIcon = (field: string) => {
        if (props.sortField === field) {
            return props.sortDirection === 'asc' ? <ArrowDropUp /> : <ArrowDropDown />;
        }
        return null;
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    const [open, setOpen] = useState(false);
    const [currentRecordId, setCurrentRecordId] = useState(0);
    const handleClose = () => setOpen(false);

    const handleOpenDeleteModal = (record: number) => {
        setOpen(true);
        setCurrentRecordId(record);
    }

    const handleDeleteInModal = () => {
        props.handleDelete(currentRecordId);
        setOpen(false);
    }


    return (
        <div>
            <Paper className="table-container">
                <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead className="table-header">
                        <TableRow>
                            <TableCell onClick={() => props.handleSort('Town')} style={{ cursor: 'pointer' }}>
                                Town {renderSortIcon('Town')}
                            </TableCell>
                            <TableCell onClick={() => props.handleSort('Candidate_Name')} style={{ cursor: 'pointer' }}>
                                Candidate Name  {renderSortIcon('Candidate_Name')}
                            </TableCell>
                            <TableCell onClick={() => props.handleSort('Candidate_Address')} style={{ cursor: 'pointer' }}>
                                Candidate Address {renderSortIcon('Candidate_Address')}
                            </TableCell>
                            <TableCell>Reports</TableCell>
                            <TableCell>Notified by City/Town Clerk</TableCell>
                            <TableCell>CPF Letter Sent</TableCell>
                            <TableCell>Report Filed</TableCell>
                            <TableCell>Matter Closed</TableCell>
                            <TableCell>Referral Date</TableCell>
                            <TableCell onClick={() => props.handleSort('Notes')} sx={{ width: '500px' }} style={{ cursor: 'pointer' }}>
                                Notes {renderSortIcon('Notes')}
                            </TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="table-body">
                        {props.localFilersWithUnfiledReports.map((record) => (
                            <TableRow key={record.localFilerRecordId}>
                                <TableCell>{record.town}</TableCell>
                                <TableCell>{record.candidateSalutation} {record.candidateName}</TableCell>
                                <TableCell>{record.candidateAddress} {record.candidateCsz}</TableCell>
                                <TableCell>
                                    {record.unfiledReports.map(report =>
                                        `${report.year} ${report.reportTypeDescription}`
                                    ).join(', ')}
                                </TableCell>
                                <TableCell>{record.notifiedByClerk}</TableCell>
                                <TableCell>{record.letterSent}</TableCell>
                                <TableCell>{record.filedDate}</TableCell>
                                <TableCell>{record.closedDate}</TableCell>
                                <TableCell>{record.referralDate}</TableCell>
                                <TableCell sx={{ width: '100px'} }>{record.notes}</TableCell>
                                <TableCell className="table-actions">
                                    <Button onClick={() => props.handleOpenFilerDialog(record, true)}>Edit</Button>
                                    <Button onClick={() => props.handleOpenReportDialog(record, true)}>Report(s)</Button>
                                    <Button onClick={() => props.handleRefer(record.candidateName, record.localFilerRecordId)}>Refer</Button>
                                    {!props.isArchived && <Button onClick={() => props.handleArchive(record.localFilerRecordId)}>Archive</Button>}
                                    <Button onClick={() => handleOpenDeleteModal(record.localFilerRecordId) }>Delete</Button>
                                </TableCell>
                            </TableRow>
                            
                        ))}
                    </TableBody>
                </Table>
            </Paper>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style }>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Are you sure?
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        This will permanently delete this record.
                    </Typography>
                    <Button color="error" onClick={() => handleDeleteInModal() }>Delete</Button>
                    <Button onClick={() => handleClose()}>Cancel</Button>
                </Box>
            </Modal>

        </div>
    )
}

export default FilerRecordsTable;